import OverviewVM from './overview-vm';
export default {
  init(node) {
    let vm = new OverviewVM();
    ko.applyBindingsWithValidation(vm, node, Kadenze.DEFAULT_VALIDATION_OPTIONS);
  }
};

